module.exports = __webpack_public_path__ + "static/media/Communicable_infectious_condition.94cfefa6.png";